import { InjectionToken } from '@angular/core';
import type { GoogleSignInConfig } from './google-sign-in.interface';

export const GOOGLE_SIGN_IN_CONFIG = new InjectionToken<GoogleSignInConfig>(
  'GoogleSignInConfig',
);
